import React, { useEffect, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import { useMedia } from 'react-use'
import HomepageVideo from '../modules/HomepageVideo'
import globals from '../globals'
import { gsap } from 'gsap'
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import AwardsHomepage from '../components/AwardsHomepage'
import HighlightText from '../components/HighlightText'
import TrustBox from '../components/TrustBox'
import { HashLink } from 'react-router-hash-link'
import { EXETEL_URL } from '../constants'

gsap.registerPlugin(MorphSVGPlugin)
window.requestAnimationFrame = window.requestAnimationFrame.bind(window) // Reqd for IE Edge in dev
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)

const BannerHome = (props) => {
    const isMobile = useMedia('(max-width: 992px)')
    const isTabletPortrait = useMedia('(min-width: 768px) and (max-width: 1024px)')

    const container = useRef(null)
    const bgShapeRight = useRef(null)
    const bgShapeRight2 = useRef(null)

    const scene2Container = useRef(null)
    const scene2Shape = useRef(null)
    const scene2Header = useRef(null)
    const scene2SubHeader = useRef(null)
    const scene2Btn = useRef(null)
    const scene2Awards = useRef(null)

    let scene2Timeout
    const tl2 = gsap.timeline()

    useEffect(() => {
        morphRightShape()

        if (!isMobile && !isTabletPortrait && scene2Header.current) {
            const headingRows = new SplitText(scene2Header.current)
            gsap.to([
                ...headingRows.lines,
                scene2SubHeader.current,
                scene2Btn.current,
                scene2Awards.current
            ], {
                duration: 1,
                y: -80,
                opacity: 0,
                stagger: 0.1,
                scrollTrigger: {
                    trigger: container.current,
                    start: 'center+=100 center',
                    end: '+=400',
                    scrub: 0.5
                }
            })
        }

        return function cleanup () {
            clearTimeout(scene2Timeout)
            tl2.clear()
        }
    }, [])

    const goToPlans = el => {
        globals.pushEvent('gtm-HomeBannerCtaClick')
        // const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        // const yOffset = -150;
        // window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
    }

    const morphRightShape = () => {
        const morph = gsap.timeline()
        morph.to(bgShapeRight.current, {
            morphSVG: {
                shape: bgShapeRight2.current,
                type: 'linear'
            },
            scrollTrigger: {
                trigger: container.current,
                start: 'center+=200 center',
                end: '+=400',
                scrub: 0.5
            }
        })
    }

    const handleClickViewPlan = (event) => {
        globals.pushGA4Events('bannerCtaClick', {
            eventInfo: {
                clickText: "View nbn Plans",
                clickUrl: window.location.href,
                pageCategory: 'Residential'
            }
        })
    }

    return (
        <div ref={container} className='homepage-banner'>
            {isMobile ? '' : <HomepageVideo height={'calc(100vh - 60px)'} />}

            <svg viewBox='0 0 1075 1033' className='bg-shape-left'>
                <path ref={scene2Shape} fill='#EFF3F4' d='M649.120435,1015.10557 C799.869652,1015.10557 1043.62159,945.567562 1060.43372,655.041155 C1073.06975,436.68107 960.603753,242.483476 721.620435,232.983476 C482.637116,223.483476 404.411231,140.711538 348.411231,-1.36424205e-12 C216.794125,-1.36424205e-12 187.445709,-1.36424205e-12 0.620434624,-1.36424205e-12 C0.620434624,71.3439839 1,825.29389 0.889379825,875.258259 C60.7958273,855.18444 113.640138,842.472045 200.857208,866.19007 C353.312942,907.64926 467.539306,1015.10557 649.120435,1015.10557 Z' />
            </svg>

            <svg viewBox='0 0 316 808' className='bg-shape-right'>
                <g transform='translate(-1605.000000, -715.000000)'>
                    <path ref={bgShapeRight} fill='#ECF9F0' d='M1606.72275,1522.52634 C1724.95821,1487.69036 1827.20078,1375.80284 1904.44806,1101.37227 C1980.94274,829.615447 1802.16339,773.153452 1605.71838,715.205859 C1605.71838,770.28419 1605.15688,1462.6 1606.72275,1522.52634 Z' transform='translate(1764.078438, 1118.866100) scale(-1, 1) translate(-1764.078438, -1118.866100)' />
                    <path ref={bgShapeRight2} style={{ display: 'none' }} fill='#ECF9F0' d='M1560.79601,1592.02007 C1609.22901,1465.2478 1723.1922,1325.00779 1858.11172,1181.3608 C2037.58086,990.282425 1795.49639,742.024507 1560.79601,795.338603 C1561.21857,826.44581 1561.21857,1541.54135 1560.79601,1592.02007 Z' transform='translate(1740.609286, 1190.010035) scale(-1, 1) translate(-1740.609286, -1190.010035)' />
                </g>
            </svg>

            <div className='d-none d-lg-flex inner-container'>
                {/* SCENE 2 (DESKTOP) */}
                <div ref={scene2Container} className='scene-2 text-left'>
                    <h1 ref={scene2Header} className='m-0 mb-1'>
                        Exetel's <HighlightText>Awesome Sale</HighlightText><br />
                        Big sale. Big deals.<br />
                        nbn plans from just $50.99/mth
                    </h1>
                    <p ref={scene2SubHeader} className='m-0 mb-5 font-small'>For the first 6 months then $63.99/mth ongoing. Available to new Exetel residential nbn™ customers
                    </p>
                    <div className='list-container'>
                        <div ref={scene2Btn} className='d-inline-block mb-3 cta'>
                            <HashLink
                                to='/broadband/nbn#sq-field-trigger'
                                onClick={handleClickViewPlan}
                                className='btn btn-custom do-animate-rollover'
                                scroll={goToPlans}
                            >View nbn™ plans
                            </HashLink>
                        </div>
                        <div className='banner-awards'>
                            <AwardsHomepage ref={scene2Awards} />
                        </div>
                    </div>
                </div>
            </div>

            <div className='review-container d-none d-lg-block'>
                <TrustBox />
            </div>

            {/* MOBILE */}
            <div className='d-lg-none'>
                <h1 className='m-0 mb-2'>
                    Exetel's <HighlightText>Awesome Sale.</HighlightText><br />
                    Big sale. Big deals. nbn plans from just $50.99/mth
                </h1>
                <p className='mt-0 mb-4 mb-md-5 font-small' style={{ lineHeight: '18px' }}>For the first 6 months then $63.99/mth ongoing. <br />Available to new Exetel residential nbn™ customers </p>
                <div className='mb-3'>
                    <HashLink
                        to='/broadband/nbn#sq-field-trigger'
                        onClick={props.handleClickChangePlan}
                        className='btn btn-custom do-animate-rollover'
                        scroll={goToPlans}
                    >View nbn™ plans
                    </HashLink>
                </div>
                <img
                    src='../images/exetel-award-mobile.svg'
                    alt='Exetel Awards'
                    className='mobile-awards-hp'
                />
            </div>
        </div>
    )
}

export default withRouter(BannerHome)



// WEBPACK FOOTER //
// ./resources/js/banners/BannerHome.js